var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tradingview",staticClass:"tradingview-widget-container",attrs:{"id":_vm.container}},[_c('div',{staticClass:"tradingview-widget-container__widget"})])}
var staticRenderFns = []

export { render, staticRenderFns }